export enum Cookie {
  currentCountry = 'currentCountry',
  currentLanguage = 'currentLanguage',
  ipCountry = 'ipCountry',
}
